import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { devicesSelector } from '../../selectors/devices';
import { setDevicesFilters } from '../../actions/filters';
import { filtersDevicesSelector, filtersDevicesToUseInQuerySelector } from '../../selectors/filters';
import FilterDevices from './FilterDevices';
import { getExportDevicesRequest, closePingEventExportDevices, getDevicesStatusesRequest, getDevicesSubstatusesRequest } from '../../actions/devices';

const mapStateToProps = createStructuredSelector({
    devices: devicesSelector,
    filters: filtersDevicesSelector,
    filtersToUseInQuery: filtersDevicesToUseInQuerySelector,
});

const mapDispatchToProps = {
    setDevicesFilters,
    getExportDevicesRequest,
    closePingEventExportDevices,
    getDevicesStatusesRequest,
    getDevicesSubstatusesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterDevices);
